/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
const baseURL = process.env.REACT_APP_AD_URL || 'http://localhost:3000/';

export const msalConfig = {
    auth: {
        clientId: "dbb9727b-0d5c-4a1f-bfec-fa5fb8cb7d38",
        authority: "https://login.microsoftonline.com/1f67262f-d37c-4cf9-8a56-fa1608024af7",
        redirectUri: `${baseURL}`,
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {		
                    case LogLevel.Error:		
                        console.error(`[MSAL Error] ${message}`);		
                        return;		
                    case LogLevel.Info:		
                        console.info(`[MSAL Info] ${message}`);		
                        return;		
                    case LogLevel.Verbose:		
                        console.debug(`[MSAL Verbose] ${message}`);		
                        return;		
                    case LogLevel.Warning:		
                        console.warn(`[MSAL Warning] ${message}`);		
                        return;
                    default:
                        console.log(`[MSAL] ${message}`);		
                        break;		
                }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
